import React from 'react';

import {
  FeatureName,
  StoreFeatureToggleDocument,
  useStoreFeatureToggleQuery,
  useToggleFeatureForStoreMutation
} from 'generated/graphql';



export interface IData {
  isEnabled: boolean;
}

export function useQuery(storeId: string, featureName: FeatureName) {
  const tuple = useStoreFeatureToggleQuery({
    variables: {
      storeId,
      featureName
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        isEnabled: !(tuple.data?.store?.isFeatureDisabled ?? false)
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useToggleStoreFeature(storeId: string, featureName: FeatureName) {
  const [fnMutate, tuple] = useToggleFeatureForStoreMutation({
    refetchQueries: [
      {
        query: StoreFeatureToggleDocument,
        variables: {
          storeId,
          featureName
        }
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (enabled: boolean) => {
      fnMutate({
        variables: {
          storeId,
          featureName,
          enabled
        }
      });
    },
    [
      featureName,
      storeId,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
